import React, { Component, useState, useEffect, useRef } from 'react'
import { fetchDataCompare } from '../util.js'
import useAxios from '../pages/useAxios';
import { Link } from 'react-router-dom';
import Select, { components } from 'react-select';


const ValueContainer = ({ children, getValue, ...props }) => {
    var values = getValue();
    var valueLabel = "";

    if (values.length > 0)
        valueLabel += props.selectProps.getOptionLabel(values[0]);
    if (values.length > 1) valueLabel += ` & ${values.length - 1} more`;

    // Keep standard placeholder and input from react-select
    var childsToRender = React.Children.toArray(children).filter(
        child =>
            ["Input", "DummyInput", "Placeholder"].indexOf(child.type.name) >= 0
    );

    return (
        <components.ValueContainer {...props}>
            {!props.selectProps.inputValue && valueLabel}
            {childsToRender}
        </components.ValueContainer>
    );
};

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

export const FYCompare = ({ fyear, state, district, month, area, indicator, areaType, indicatorCategory, stateDropdown, districtDropdown, fyDropdown, indicatorDropdown, setAreaType, setIndicator, setArea, setMonth, setFyear, setState, setDistrict, status, setbarChartData, setLineChartData, setTableData, setQualityData, isSelected, setIsSelected, toggleValue, setFound }) => {
    const api = useAxios();
    let found_1 = indicatorDropdown.filter(e => e.indicator_id === indicator[0])[0].variant;

    if (toggleValue === 'count') {
        if (found_1 === 'Numeric' || found_1 === 'Both') {
            setFound(true);
        } else {
            setFound(false);
        }
    } else {
        if (found_1 === 'Percent' || found_1 === 'Both') {
            setFound(true);
        } else {
            setFound(false);
        }
    }

    const handleFinancialYear = async (e) => {
        setIsSelected(false);

        let val = Array.isArray(e) ? e.map(x => x.value) : [e.value];
        setFyear(val);

        let fyearSelected = val.join(',');
        await fetchDataCompare(fyearSelected, month, area, indicator, areaType, indicatorCategory, status, setbarChartData, setLineChartData, setTableData, setQualityData, api);
        setIsSelected(true);
    };

    const handleIndicatorChange = async (e) => {
        setIsSelected(false);

        let val = e.target.value;
        setIndicator([Number(val)]);

        let indicatorSelected = val;
        await fetchDataCompare(fyear, month, area, indicatorSelected, areaType, indicatorCategory, status, setbarChartData, setLineChartData, setTableData, setQualityData, api);
        setIsSelected(true);
    };

    const handleStateChange = async (e) => {
        setIsSelected(false);

        const districtName = e.target.value;
        let areaSelected = 1
        let areaTypeSelected = 'State';
        if (districtName == 1) {
            setAreaType('State');
            setArea(1);
            setDistrict(774);
        }
        else {
            setAreaType('District');
            areaSelected = districtName;
            areaTypeSelected = 'District';
            setArea(districtName);
        }
        setState(districtName);

        await fetchDataCompare(fyear, month, areaSelected, indicator, areaTypeSelected, indicatorCategory, status, setbarChartData, setLineChartData, setTableData, setQualityData, api)
        setIsSelected(true);
    };

    const handleDistrictChange = async (e) => {
        setIsSelected(false);

        const subdtName = e.target.value;
        let areaSelected = state;
        let areaTypeSelected = 'District';
        setAreaType('District');
        setArea(subdtName);

        if (subdtName == 774) {
            setAreaType('District');
            setArea(state);
        }
        else {
            setAreaType('District');
            setArea(subdtName);
            areaTypeSelected = 'District';
            areaSelected = subdtName;
        }

        setDistrict(subdtName);
        await fetchDataCompare(fyear, month, areaSelected, indicator, areaTypeSelected, indicatorCategory, status, setbarChartData, setLineChartData, setTableData, setQualityData, api)
        setIsSelected(true);
    };


    return (
        <React.Fragment>
            <form action="" class="mb-3">
                <div class="flex flex-wrap md:flex-row">
                    <div className='flex w-full lg:w-1/5'>
                        <div className='flex-col w-11/12'>
                            <label for="" class="block mb-1 mt-2 md:mt-0 text-base lg:text-lg font-bold text-black">Select Financial Year</label>
                            <Select
                                className='bg-gray-50 border border-gray-500 text-black text-base md:text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full'
                                options={fyDropdown.map(e => ({ label: e.fy_name, value: e.fy_id }))}
                                closeMenuOnSelect={true}// set list of the data
                                onChange={handleFinancialYear} // assign onChange function
                                isMulti
                                defaultValue={{ label: "2019-2020", value: 3 }}
                                maxMenuHeight="50"
                                showCheckbox={true}
                                hideSelectedOptions={false}
                                isDisabled={!isSelected}
                                components={{
                                    ValueContainer,
                                    Option
                                }}
                            />
                        </div>
                    </div>

                    <div className='flex w-full lg:w-2/5'>
                        <div className='flex-col w-11/12'>
                            <label for="" class="block mb-1 mt-2 md:mt-0 text-base lg:text-lg font-bold text-black">Select Indicator</label>
                            <select name="indicator" id="" class="form-select bg-gray-50 border border-gray-500 text-black text-base md:text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5"
                                value={indicator}
                                onChange={handleIndicatorChange}
                                disabled={!isSelected}>
                                {indicatorDropdown.sort((a, b) => a.category - b.category).map((indicator) => {
                                    return (
                                        <option value={indicator.indicator_id}>{indicator.label}</option>
                                    )
                                })
                                }
                            </select>
                        </div>
                    </div>

                    <div className='flex w-full md:w-1/2 lg:w-1/5'>
                        <div className='flex-col w-11/12'>
                            <label for="" class="block mb-1 mt-2 md:mt-0 text-base lg:text-lg font-bold text-black">Select State</label>
                            <select name="state" id="" class="form-select bg-gray-50 border border-gray-500 text-black text-base md:text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5"
                                value={state}
                                onChange={handleStateChange}
                                disabled={!isSelected}>
                                {
                                    stateDropdown.map((data) => {
                                        return (
                                            <option value={data.area_id}>{data.area_name}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>

                    <div className='flex w-full md:w-1/2 lg:w-1/5'>
                        <div className='flex-col w-11/12'>
                            <label for="" class="block mb-1 mt-2 md:mt-0 text-base lg:text-lg font-bold text-black">Select District</label>
                            <select name="subdt" id="" class="form-select bg-gray-50 border border-gray-500 text-black text-base md:text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5"
                                value={district}
                                onChange={handleDistrictChange}
                                disabled={!isSelected}>
                                <option value={774}>All</option>
                                {
                                    districtDropdown.filter(district => district.area_parent_id == state).map(filtered_subdt => {
                                        return (

                                            <option value={filtered_subdt.area_id}>{filtered_subdt.area_name}</option>
                                        )
                                    }
                                    )
                                }
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </React.Fragment>
    )
}

export default FYCompare